module.exports = __webpack_public_path__ + "static/media/family-on-stoop-2.3f562304.jpg";